/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

function EpgFocusedDetailSkeleton({ emptyMessage }) {
  return (
    <div className={`dtv-html5-c-epg__detail-container ${emptyMessage ? 'dtv-html5-c-epg__detail-container--empty-message' : ''}`}>
      <Skeleton className={`dtv-html5-c-epg__detail-preview--skeleton ${emptyMessage ? 'dtv-html5-c-epg__detail-container__skeleton--empty-message dtv-html5-c-epg__detail-preview--skeleton-empty-message' : ''}`} />
      <div className="dtv-html5-c-epg__detail-metadata">
        <Skeleton
          className={`dtv-html5-c-epg__detail-metadata__live-start--skeleton ${emptyMessage ? 'dtv-html5-c-epg__detail-container__skeleton--empty-message dtv-html5-c-epg__detail-metadata__live-start--skeleton-empty-message' : ''}`}
        />
        <Skeleton
          className={`dtv-html5-c-epg__detail-metadata__title--skeleton ${emptyMessage ? 'dtv-html5-c-epg__detail-container__skeleton--empty-message dtv-html5-c-epg__detail-metadata__title--skeleton-empty-message' : ''}`}
        />
        <Skeleton
          className={`dtv-html5-c-epg__detail-metadata__content-information--skeleton ${emptyMessage ? 'dtv-html5-c-epg__detail-container__skeleton--empty-message dtv-html5-c-epg__detail-metadata__content-information--skeleton-empty-message' : ''}`}
        />
        <Skeleton
          className={`dtv-html5-c-epg__detail-metadata__description--skeleton ${emptyMessage ? 'dtv-html5-c-epg__detail-container__skeleton--empty-message dtv-html5-c-epg__detail-metadata__description--skeleton-empty-message' : ''}`}
        />
      </div>
    </div>
  );
}

EpgFocusedDetailSkeleton.propTypes = {
  emptyMessage: PropTypes.bool,
};

EpgFocusedDetailSkeleton.defaultProps = {
  emptyMessage: false,
};

export default memo(EpgFocusedDetailSkeleton);
